/* istanbul ignore file */

import router from '../../router';

const state = {
  contact: null,
  contacts: null,
  services: null,
  schedules: null,
  searchResult: null,
  paging: {
    current: 0,
    pageSize: 5,
    totalItems: 0,
  },
  loading: false,
};
const mutations = {
  setContact(st, contact) {
    st.contact = contact;
  },
  setContacts(st, contacts) {
    st.contacts = contacts;
  },
  setSearchResult(st, result) {
    st.searchResult = result;
  },
  setServices(st, services) {
    st.services = services;
  },
  setSchedules(st, schedules) {
    st.schedules = schedules;
  },
  setPaging(st, paging) {
    st.paging = paging;
  },
  setTotalItems(st, total) {
    st.paging.totalItems = total;
  },
  setCurrent(st, current) {
    st.paging.current = current;
  },
  setLoading(st, loading) {
    st.loading = loading;
  },
};
const getters = {
  contactTypes() {
    return [
      {
        label: 'Sugestão',
        value: 11715124,
      }, {
        label: 'Orçamento',
        value: 11715150,
      }, {
        label: 'Reclamação',
        value: 11715151,
      }, {
        label: 'Dúvida',
        value: 12429911,
      }, {
        label: 'Atualização cadastral',
        value: 12430375,
      }, {
        label: 'Solicitação',
        value: 127514862,
      }, {
        label: 'Agrupamento de CNPJ',
        value: 773898952,
      }, {
        label: 'Elogio',
        value: 1028885044,
      }, {
        label: 'Outros',
        value: 29568153,
      }
      //, {
      //  label: 'Atendimento Técnico',
      //  value: 2,
    //},
    ];
  },

  servicesList() {
    return state.services;
  },

  getAgenda() {
    return state.schedules;
  },

  getPaging() {
    return state.paging;
  },

  isLoading() {
    return state.loading;
  },
};
const actions = {

  haveMoreContacts() {
    return state.searchResult.length < state.paging.totalItems;
  },

  clearContacts({ commit }) {
    commit('setContacts', []);
    commit('setSearchResult', []);
  },

  searchContact({ commit }, text = '') {
    const contactFilter = (contact) => {
      const target = text.toUpperCase();
      const props = [
        'categoria',
        'atendente',
        'codigoTarefa',
        'contato',
        'descricao',
        'link',
        'neoid',
        'solicitante',
      ];
      const checkProps = p => contact[p]
        && typeof contact[p] === 'string'
        && contact[p].toUpperCase().match(target);
      return props.some(checkProps);
    };
    const result = state.contacts.filter(contactFilter);
    commit(
      'setSearchResult', result,
    );
  },

  filterContacts({ commit, state: st }, typeId) {
    const filterContactsByType = (contact) => {
      if (!typeId) return true;
      return contact.type === typeId;
    };
    const filteredContacts = st.contacts.filter(filterContactsByType);
    commit('setSearchResult', filteredContacts.slice(0, 30));
  },

  loadContact({ commit, state: st }, id) {
    const result = st.contacts.filter(
      c => c.codigoTarefa === String(id),
    );
    if (result.length === 1) {
      commit('setContact', result[0]);
    } else {
      throw Error('contact not found');
    }
  },

  resetPaging({ commit }) {
    const paging = { current: 0, pageSize: 5, totalItems: 0 };
    commit('setPaging', paging);
  },

  async loadContacts({ dispatch, rootState, commit }, { type, cb }) {
    const { currentAccount, currentUser } = rootState.session;
    const { cpfCnpjOwner, contractCode, userOwnerId } = currentAccount;
    const url = `/portalcliente/v2/listaContato/${cpfCnpjOwner}/${contractCode}`;
    const paging = getters.getPaging();
    const params = {
      admin: userOwnerId === currentUser.id,
      type,
      recordsPerPage: paging.pageSize,
      offSet: paging.current,
    };
    const method = 'get';
    const onError = () => {
      this.$notify('Erro ao carregar contatos.');
    };
    try {
      const res = await Promise.any([
        dispatch('mobileRequests/create', { url, params, method }, { root: true }),
      ]);
      if (res.data.status === 100) {
        if (res.data.ret.length === 0) {
          this.$notify('Não foram encontradas solicitações.');
          return;
        }
        commit('setTotalItems', res.data.totalItems);
        const contacts = state.contacts ? state.contacts.concat(res.data.ret) : res.data.ret;
        commit('setContacts', contacts);
        commit('setSearchResult', contacts);

        const current = paging.current + paging.pageSize;
        commit('setCurrent', current);
        cb !== undefined && cb();
      } else {
        onError();
      }
    } catch (e) {
      onError(e);
    }
  },

  async loadServices({ dispatch, rootState, commit }) {
    const urlServices = 'portalcliente/v2/minhasegurancaeletronica';
    const { currentAccount } = rootState.session;
    const { cpfCnpjOwner, contractCode } = currentAccount;
    const params = {
      cpfCnpj: cpfCnpjOwner,
      contractCode,
    };
    const method = 'get';
    const onError = () => {
      this.$notify('Erro ao carregar serviços.');
    };
    try {
      const res = await Promise.any([
        dispatch('mobileRequests/create', { url: urlServices, params, method }, { root: true }),
      ]);
      if (res.data.status === 100) {
        const services = res.data.ret;

        commit('setServices', services);
      } else {
        onError();
      }
    } catch (e) {
      onError(e);
    }
  },

  async loadSchedules({ dispatch, rootState, commit }, id) {
    const urlSchedules = `portalcliente/v1/sigma-service/os/technician-schedule/${id}`;
    const initialdate = new Date();
    const endDate = new Date();
    endDate.setDate(endDate.getDate() + 3);
    const params = {
      dateInit: initialdate.toISOString().replace(/T/, ' ').replace(/\..+/, '').slice(0, 16),
      dateEnd: endDate.toISOString().replace(/T/, ' ').replace(/\..+/, '').slice(0, 16),
    };
    const method = 'get';
    const onError = () => {
      this.$notify('Erro ao carregar serviços.');
    };
    try {
      const res = await Promise.any([
        dispatch('mobileRequests/create', { url: urlSchedules, params, method }, { root: true }),
      ]);
      if (res.data.status === 100) {
        const schedules = res.data.ret;

        commit('setSchedules', schedules);
      } else {
        onError();
      }
    } catch (e) {
      onError(e);
    }
  },

  async onAddClick({ dispatch, getters: gt, rootState }, payload) {
    const {
      contact,
      onSuccess = () => { },
    } = payload;
    const { cpfCnpjOwner, contractCode } = rootState.session.currentAccount;

    const data = {
      nome: contact.name,
      email: contact.email,
      mensagem: contact.message,
      telefone: contact.phone,
      tipoContato: contact.contactType,
      schduleDate: contact.schedule,
      cpfCnpj: cpfCnpjOwner,
      contractCode,
    };

    if (contact.contactType === 2) {
      data.os = helpers.getOs(rootState.session.currentAccount, contact);
    }

    const contactTypeLabel = gt.contactTypes.find(
      cont => cont.value === contact.contactType,
    ).label;
    const url = '/portalcliente/v2/salvarcontato';
    const method = 'post';
    const onError = () => {
      this.$notify(`Erro ao enviar ${contactTypeLabel}.`);
    };

    try {
      const res = await dispatch('mobileRequests/create', { url, data, method }, { root: true });
      if (res.data.status === 100) {
        this.$notify(
          `${contactTypeLabel} enviado(a) para análise. Em breve enviaremos um email com a confirmação.`,
          'success',
        );
        if (data.os != null) {
          data.os.id = res.data.ret;
        }
        onSuccess(data);
      } else {
        onError();
      }
    } catch (e) {
      onError();
    }
  },

  async serviceCall({ dispatch, commit, state: st }, data) {
    const { identity } = router.currentRoute.query;
    const url = `/portalcliente/v2/os-blip${identity ? `?identity=${identity}` : ''}`;
    const method = 'post';

    try {
      const res = await dispatch('mobileRequests/create', { url, data, method }, { root: true });
      if (res.data === 200) {
        this.$notify(
          'Logo enviaremos uma mensagem para o seu contato com mais informações sobre a Ordem de Serviço.',
          'success',
        );
        router.push({ name: 'Success' });
      }
    } catch (e) {
      this.$notify('Erro ao enviar mensagem, por favor entre contato conosco pelo whatsapp', 'error');
    }
    commit('setLoading', !st.loading);
  },

  async switchLoading({ commit, state: st }) {
    commit('setLoading', !st.loading);
  },
};

const helpers = {

  getOs(account, contact) {
    const customer = {
      id: contact.service.cdCliente,
      centralId: contact.service.central,
      cpfCnpj: account.cpfCnpjOwner,
      contract: account.id,
    };

    return {
      problemId: 1288,
      requesterId: 10030,
      customer,
      technicianId: contact.service.technicianId,
      log: contact.message,
    };
  },


};
export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
